<template>
    <v-container>
        <v-row>
            <v-subheader class="page-header">Employees</v-subheader>
        </v-row>
        <v-spacer />
        <router-view :employees="employees" :locations="locations" />
    </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Employee',
    computed: {
        ...mapState({
            employees: 'employees',
            locations: 'locations'
        })
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            this.getEmployees();
            this.getLocations();
        },

        getEmployees() {
            this.$store.dispatch('employeeRead');
        },

        getLocations() {
            this.$store.dispatch('locationRead');
        }
    }
};
</script>
